export const firebaseConfig = {
 apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
 authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
 projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
 storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
 messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
 databaseURL:
  process.env.REACT_APP_FIREBASE_DATABASE_URL ||
  "https://shopmyinfluence-dev.firebaseio.com",
};
